import { TARIFFS_LIMITS_ADD_ONS_TABLE_CONFIG_API } from '../constants/api'
import { getApi, postApi, putApi } from '../utils/api'

export function getTariffOverview(params) {
  return getApi({ endpoint: 'api/tariff-overview/', params })
}

export function getTariffOverrides(params) {
  return getApi({ endpoint: 'api/tariff-override/', params })
}

export function getTariff(params) {
  return getApi({ endpoint: 'api/tariff/', params })
}

export function requestTariffAddOn(data) {
  return postApi({ data, endpoint: 'api/tariff-overview/request-addon/' })
}

export function updateTariffOverridesTableConfig(data) {
  return putApi({
    data,
    endpoint: `${TARIFFS_LIMITS_ADD_ONS_TABLE_CONFIG_API}config/`,
  })
}
